import CustomInput from './Input';

export default CustomInput;
